import { Box, Flex, GridItem, Link } from "@chakra-ui/layout";
import { Divider, Heading, Image, Tag } from "@chakra-ui/react";
import { Modal } from "antd";
import { StatusAutorizacaoPortaria } from "core/features/portaria/typings";
import colors from "core/resources/theme/colors";
import { formatPhone } from "infra/helpers/number";
import FooterModal from "ui/components/Button/FooterModal";
import CardPerson from "ui/components/Cards/CardPerson";

interface CardPersonProp {
  id: string;
  nome: string;
  imagemUrl: string;
}

interface ModalDetalhePortariaProps {
  autorizacaoId: string;
  pessoa?: CardPersonProp;
  avatarBorder?: string;
  avatarBackgroundColor?: string;
  observacao: string | null;
  date?: string;
  dateStart?: string;
  dateEnd?: string;
  acompanhante: number | null;
  nomeMorador: string;
  telefone?: string;
  unidade: string;
  visible: boolean;
  onClose: () => any;
  foto?: string;
  documento?: string;
  status?: StatusAutorizacaoPortaria;
  disableConfirmar?: boolean;
  onConfirm?: () => any;
  isLoadingConfirmar?: boolean;
  cnh?: string;
}

function ModalDetalhePortaria({
  pessoa,
  avatarBorder,
  avatarBackgroundColor,
  observacao,
  date,
  dateStart,
  dateEnd,
  acompanhante,
  nomeMorador,
  telefone,
  unidade,
  visible,
  onClose,
  foto,
  documento,
  status,
  disableConfirmar,
  onConfirm,
  isLoadingConfirmar,
  cnh,
}: ModalDetalhePortariaProps) {
  const _isDisabled =
    disableConfirmar || status === StatusAutorizacaoPortaria.Confirmado;

  return (
    <Modal
      width={"750px"}
      footer={
        <FooterModal
          showRegisterAnother={false}
          registerAnother={false}
          onSubmit={_isDisabled ? undefined : onConfirm}
          hidePrimaryButton={_isDisabled}
          isDisabled={_isDisabled}
          isLoadingSave={isLoadingConfirmar}
          onClose={onClose}
          primaryButtonText={"Confirmar"}
          buttonCancelarText="Voltar"
          primaryButtonBgColor={colors.green500}
          primaryButtonHtmlTitle={
            disableConfirmar
              ? "Você só pode confirmar a portaria no dia correspondente."
              : status === StatusAutorizacaoPortaria.Confirmado
              ? "Portaria já confirmada"
              : undefined
          }
        />
      }
      visible={visible}
      onCancel={onClose}
    >
      <Flex flexDir="column">
        <Heading mb={4} size="md">
          Mais informações
        </Heading>
        {status === StatusAutorizacaoPortaria.Confirmado ? (
          <Tag colorScheme="green" rounded="full" w="fit-content" mb={4}>
            Confirmado
          </Tag>
        ) : null}
      </Flex>

      <Divider mb={4} />

      <Box py="4px">
        <CardPerson
          avatarUrl={pessoa?.imagemUrl}
          nome={pessoa?.nome}
          subtitle={unidade}
          // date={date}
          dateStart={dateStart}
          dateEnd={dateEnd}
          isPeriod
          border={avatarBorder}
          backgroundColor={avatarBackgroundColor}
        />
        <Flex justifyContent="space-between" mt={8} mb={8}>
          <GridItem w="max-content">
            <Flex direction="column">
              <Flex color="#768398" fontSize="12px">
                QUANTIDADE DE PESSOAS:
              </Flex>
              <Flex fontSize="12px">{acompanhante ?? "--"}</Flex>
            </Flex>
          </GridItem>

          <GridItem w="max-content" colSpan={2}>
            <Flex direction="column">
              <Flex alignItems="center">
                <Box mr="4px" color="#768398" fontSize="12px">
                  SOLICITANTE:
                </Box>
              </Flex>

              <Box lineHeight="14px" w="100%" fontSize="12px">
                {nomeMorador}
              </Box>
            </Flex>
          </GridItem>

          {telefone ? (
            <GridItem w="max-content" colSpan={2}>
              <Flex direction="column">
                <Flex alignItems="center">
                  <Box mr="4px" color="#768398" fontSize="12px">
                    CONTATO:
                  </Box>
                </Flex>

                <Box lineHeight="14px" w="100%" fontSize="12px">
                  {formatPhone(telefone)}
                </Box>
              </Flex>
            </GridItem>
          ) : null}

          <GridItem w="max-content">
            <Flex direction="column">
              <Box w="100%" color="#768398" fontSize="12px">
                UNIDADE:
              </Box>
              <Box w="100%" fontSize="12px">
                {unidade}
              </Box>
            </Flex>
          </GridItem>
        </Flex>
      </Box>

      {cnh ? (
        <Box>
          <GridItem w="100%">
            <Flex direction="column">
              <Flex color="#768398" fontSize="12px">
                CNH:
              </Flex>
              <Flex fontSize="12px" mb={10}>
                {cnh}
              </Flex>
            </Flex>
          </GridItem>
        </Box>
      ) : null}

      {observacao ? (
        <Box>
          <GridItem w="100%">
            <Flex direction="column">
              <Flex color="#768398" fontSize="12px">
                DESCRIÇÃO:
              </Flex>
              <Flex fontSize="12px" mb={10}>
                {observacao}
              </Flex>
            </Flex>
          </GridItem>
        </Box>
      ) : null}

      <Flex gap={4}>
        {foto ? (
          <Link href={foto} target="_blank" rel="noopener noreferrer">
            <Image src={foto} borderRadius={5} h="40" />
          </Link>
        ) : null}

        {documento ? (
          <Link href={documento} target="_blank" rel="noopener noreferrer">
            <Image src={documento} borderRadius={5} h="40" />
          </Link>
        ) : null}
      </Flex>
    </Modal>
  );
}

export default ModalDetalhePortaria;
